import { FC } from 'react';
import { observer } from 'mobx-react';
import { GlobalSearchLoader } from './global-search-loader';
import { GLOBAL_SEARCH_MFE_PRODUCTION_URL } from './constants';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { FeatureFlags } from '../../common/models/feature-flags';

export const GlobalSearchMFE: FC = observer(() => {
    const { globalSearchMfeUrl } = useFlags<FeatureFlags>();

    const src = globalSearchMfeUrl || GLOBAL_SEARCH_MFE_PRODUCTION_URL;

    return <GlobalSearchLoader src={src} />;
});
